import store from './store'

export async function ensureStartApp (doneFn) {
  if (store.state.app.started) {
    doneFn()
  } else {
    await store.dispatch('app/start')
    doneFn()
  }
}
